<template>
  <div id="style-guide">
    <div class="app-nav">
      <div class="row expanded">
        <div class="columns">
          <nav></nav>
        </div>
      </div>
    </div>
    <main>
      <div class="row">
        <div class="columns">
          <div id="form" class="mainDiv" v-if="forPrint === false">
            <form id="request">
              <!--<errors v-bind:notifications="msg"/>-->
              <ul class="radioNoBullet">
                <li v-for="group in errors.collect()">
                  <ul>
                    <li v-for="error in group">{{ error }}</li>
                  </ul>
                </li>
              </ul>
              <div class="large-12 columns">
                <label for="firstname">FIRSTNAME</label>
                <input
                  id="firstname"
                  name="FirstName"
                  v-model.lazy.trim="firstName"
                  v-validate="'required'"
                  maxlength="50"
                  type="text"
                  autocomplete="off"
                  :class="{
                    'sg-input-error': errors.has('FirstName'),
                  }"
                />
              </div>
              <div class="large-12 columns">
                <label for="lastname">LASTNAME</label>
                <input
                  id="lastname"
                  name="LastName"
                  v-model.lazy.trim="lastName"
                  v-validate="'required'"
                  maxlength="50"
                  type="text"
                  autocomplete="off"
                  :class="{
                    'sg-input-error': errors.has('LastName'),
                  }"
                />
              </div>
              <div class="large-12 columns">
                <label for="address">ADDRESS</label>
                <input
                  id="address"
                  name="Address"
                  type="text"
                  v-model.lazy.trim="address"
                  v-validate="'required|vAddress'"
                  maxlength="100"
                  @change="VerifyAddress()"
                  autocomplete="off"
                  :class="{
                    'sg-input-error': errors.has('Address'),
                  }"
                />
              </div>
              <div class="large-6 columns">
                <label for="unit">APT/UNIT</label>
                <input
                  id="unit"
                  name="unit"
                  v-model.lazy.trim="unit"
                  maxlength="5"
                  type="text"
                  autocomplete="off"
                />
              </div>
              <div class="large-6 columns">
                <label for="zipcode">ZIPCODE</label>
                <input
                  id="zipcode"
                  name="ZipCode"
                  v-model.lazy.trim="zipCode"
                  v-validate="'required'"
                  maxlength="5"
                  type="text"
                  autocomplete="off"
                  readonly="readonly"
                  :class="{
                    'sg-input-error': errors.has('ZipCode'),
                  }"
                />
              </div>
              <div class="large-18 columns">
                <label for="email">EMAIL</label>
                <input
                  type="text"
                  id="email"
                  v-model.lazy.trim="email"
                  v-validate="'required|email'"
                  name="Email"
                  autocomplete="off"
                  :class="{
                    'sg-input-error': errors.has('Email'),
                  }"
                />
              </div>
              <div class="large-6 columns">
                <label for="phone">PHONE</label>
                <input
                  id="phone"
                  name="Phone"
                  v-model.lazy.trim="phone"
                  v-validate="'required|min:10'"
                  maxlength="14"
                  type="text"
                  v-mask="'(###) ###-####'"
                  autocomplete="off"
                  :class="{
                    'sg-input-error': errors.has('Phone'),
                  }"
                />
              </div>
              <!--<div class="large-6 columns">
                    <label for="pickupdate">PICKUP DATE</label>
                    <datepicker id="pickupdate" name="pickupdate"></datepicker>
              </div>-->
              <!--<div class="large-12 columns">
                    <label for="pickuplocation">PICKUP LOCATION</label>
                    <select id="pickuplocation"
                            name="PickupLocation"
                            v-model="pickupLocationId"
                            v-validate="{ is_not: 0 }">
                        <option v-bind:value="0">Choose the pickup location</option>
                        <option v-for="option in pickupLocations"
                                v-bind:key="option.locId"
                                v-bind:value="option.locId">
                            {{ option.location }}
                        </option>
                    </select>
              </div>-->
              <div class="large-12 columns">
                <label>REASON</label>
                <ul class="radioNoBullet" v-if="reasons && reasons.length">
                  <li v-bind:key="reason.id" v-for="reason of reasons">
                    <input
                      type="radio"
                      v-bind:value="reason.id"
                      :id="'radio_' + reason.id"
                      v-model.lazy.trim="reasonSelected"
                      v-validate="'required|included:1,2'"
                      name="Reason"
                    />
                    <label :for="'radio_' + reason.id">{{
                      reason.reason
                    }}</label>
                  </li>
                </ul>
              </div>
              <!--<div class="large-24 columns">
                    <br>
                    <input id="chkrewards" type="checkbox" v-model.lazy.trim="rewards">
                    <label for="chkrewards">Are you registered for the Recycling Rewards program?</label>
                </div>
                <div class="large-24 columns">
                    <input id="chkphilacycle" type="checkbox" v-model.lazy.trim="philaCycle">
                    <label for="chkphilacycle">I want to get rewarded for recycling! By checking this box, I understand that I'm joining the Philacycle program.</label>
                    <br>
              </div>-->

              <div class="large-24 columns">
                <br />
                <label
                  >YOU MUST PICK-UP YOUR RECYCLING BIN AT ONE OF THE FOLLOWING
                  SIX LOCATIONS:</label
                >
                <ul>
                  <li>
                    Northeast Philadelphia Sanitation Convenience Center --
                    State Rd. & Ashburner St.
                  </li>
                  <li>
                    Northwest Philadelphia Sanitation Convenience Center --
                    Domino Lane & Umbria St
                  </li>
                  <li>
                    Port Richmond Sanitation Convenience Center -- 3901 Delaware
                    Ave.
                  </li>
                  <li>
                    Southwest Philadelphia Sanitation Convenience Center -- 3303
                    S. 63rd St.
                  </li>
                  <li>
                    Strawberry Mansion Sanitation Convenience Center -- 2601 W.
                    Glenwood Ave.
                  </li>
                  <li>
                    West Philadelphia Sanitation Convenience Center -- 5100
                    Grays Ave.
                  </li>
                </ul>
                <a
                  href="https://www.philadelphiastreets.com/sanitation/residential/sanitation-convenience-centers/"
                  target="_blank"
                  >Click here for hours of operation and detailed location
                  information</a
                >
                <br />
                <br />
                <a
                  href="https://philadelphiastreets.com/recycling/"
                  target="_blank"
                  >Click here to learn more about recycling properly</a
                >
              </div>

              <div class="columns medium-6 end">
                <br />
                <p>
                  <a href :class="disabledClass" @click.prevent="onSubmit()"
                    >SUBMIT</a
                  >
                </p>
                <br />
              </div>
              <div class="columns medium-6 end">
                <br />
                <p>
                  <a
                    href
                    class="button content-type-featured full"
                    @click.prevent="onCancel()"
                    >CANCEL</a
                  >
                </p>
                <br />
              </div>
            </form>
          </div>
          <div id="divPrint" class="mainDiv" v-if="forPrint === true">
            <div class="large-24 columns">
              <br />
              <span class="divx">
                <b>REQUEST#</b>
                {{ requestId }}
              </span>
            </div>
            <div class="large-24 columns">
              <span class="divx">
                <b>FIRSTNAME:</b>
                {{ firstName }}
              </span>
            </div>
            <div class="large-24 columns">
              <span class="divx">
                <b>LASTNAME:</b>
                {{ lastName }}
              </span>
            </div>
            <div class="large-24 columns">
              <span class="divx">
                <b>ADDRESS:</b>
                {{ address }}
              </span>
            </div>
            <div class="large-24 columns">
              <span class="divx">
                <b>APT/UNIT:</b>
                {{ unit }}
              </span>
            </div>
            <div class="large-24 columns">
              <span class="divx">
                <b>ZIPCODE:</b>
                {{ zipCode }}
              </span>
            </div>
            <div class="large-24 columns">
              <span class="divx">
                <b>EMAIL:</b>
                {{ email }}
              </span>
            </div>
            <div class="large-24 columns">
              <span class="divx">
                <b>PHONE:</b>
                {{ phone }}
              </span>
            </div>
            <div class="large-24 columns">
              <br />
              <label class="divx">REASON:</label>
              <ul class="radioNoBullet divx" v-if="reasons && reasons.length">
                <li v-bind:key="reason.id" v-for="reason of reasons">
                  <input
                    class="divx"
                    type="radio"
                    v-bind:value="reason.id"
                    :id="'radio_p' + reason.id"
                    v-model.lazy.trim="reasonSelected"
                    name="Reason"
                    disabled
                  />
                  <label class="divx" :for="'radio_' + reason.id">{{
                    reason.reason
                  }}</label>
                </li>
              </ul>
            </div>
            <div class="large-24 columns divx">
              <br />
              <label class="divx"
                >YOU MUST PICK-UP YOUR RECYCLING BIN AT ONE OF THE FOLLOWING SIX
                LOCATIONS:</label
              >
              <ul class="divx">
                <li>
                  Northeast Philadelphia Sanitation Convenience Center -- State
                  Rd. & Ashburner St.
                </li>
                <li>
                  Northwest Philadelphia Sanitation Convenience Center -- Domino
                  Lane & Umbria St
                </li>
                <li>
                  Port Richmond Sanitation Convenience Center -- 3901 Delaware
                  Ave.
                </li>
                <li>
                  Southwest Philadelphia Sanitation Convenience Center -- 3303
                  S. 63rd St.
                </li>
                <li>
                  Strawberry Mansion Sanitation Convenience Center -- 2601 W.
                  Glenwood Ave.
                </li>
                <li>
                  West Philadelphia Sanitation Convenience Center -- 5100 Grays
                  Ave.
                </li>
              </ul>
            </div>

            <div class="columns medium-6 end">
              <br />
              <p>
                <a
                  href
                  class="button content-type-featured full noprint"
                  @click.prevent="print()"
                  >PRINT</a
                >
              </p>
              <br />
            </div>
            <div class="columns medium-6 end">
              <br />
              <p>
                <a
                  href
                  class="button content-type-featured full noprint"
                  @click.prevent="onCancel()"
                  >NEW REQUEST</a
                >
              </p>
              <br />
            </div>
          </div>
          <modal
            v-show="isModalVisible"
            :headerMessage="modalHeader"
            :bodyMessage="modalBody"
            @close="closeModal"
          />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

//Components
import modal from "../components/Modal";

// Local Directive
import { mask } from "vue-the-mask";

export default {
  components: {
    modal,
  },
  directives: {
    mask,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      address: "",
      unit: "",
      zipCode: "",
      email: "",
      phone: "",
      pickupDate: "",
      reason: false,
      rewards: false,
      philaCycle: false,
      reasons: [],
      msg: [],
      pickupLocations: [],
      reasonSelected: "",
      checked: false,
      pickupLocationId: 0,
      token: "",
      isModalVisible: false,
      mHeader: "",
      mBody: "",
      isCompleted: false,
      requestId: "",
      isButtonDisabled: false,
      urlApi: process.env.VUE_APP_API_BASE_URL || "/api",
      urlAis: process.env.VUE_AIS_HOST,
    };
  },
  // Fetches FormData when the component is created.
  created() {
    axios
      .all([
        axios.get(`${this.urlApi}/formData/GetPickupLocations`),
        axios.get(`${this.urlApi}/formData/GetRequestReasons`),
      ])
      .then(
        axios.spread((pickupLocations, reasons) => {
          (this.pickupLocations = pickupLocations.data),
            (this.reasons = reasons.data),
            this.$store.dispatch("setPickupLocation", pickupLocations.data),
            this.$store.dispatch("setReasons", reasons.data);
        })
      )
      .catch((e) => {
        this.msg.push(e);
      });
  },
  methods: {
    VerifyAddress() {
      this.zipCode = "";
      if (address.value != "") {
        var gateKeeperKey = process.env.VUE_GATEKEEPERKEY;
        axios
          .get(`${this.urlAis}/${address.value}${gateKeeperKey}`)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.$store
              .dispatch("setAisAddress", response.data)
              .then((data) => {
                this.address = data.features[0].properties.street_address;
                this.zipCode = data.features[0].properties.zip_code;
                this.$store.dispatch("setIsAddressValid", true);
              })
              .catch((e) => {
                this.$store.dispatch("setIsAddressValid", false);
                this.msg.push(e);
              });
          })
          .catch((e) => {
            this.$store.dispatch("setIsAddressValid", false);
            this.msg.push(e);
          });
      }
    },
    async getToken() {
      await axios({
        method: "POST",
        url: `${this.urlApi}/FormData/GetToken`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: {
          username: "xxx",
          password: "yyy@",
        },
      })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.token = response.data.access_token;
          //console.log(response.data.access_token);
        })
        .catch((e) => {
          this.msg.push(e);
        });
    },
    saveRequest() {
      //this.getToken();
      var self = this;

      this.$validator.validate().then((valid) => {
        if (valid) {
          self.isButtonDisabled = true;
          const formData = {
            FirstName: firstname.value,
            LastName: lastname.value,
            StreetAddress: address.value,
            Unit: unit.value,
            City: "Philadelphia",
            State: "PA",
            Zipcode: parseInt(zipcode.value),
            Email: email.value,
            Phone: phone.value,
            //PickupDate: moment(this.$store.getters.date).format("MM/DD/YYYY"),
            //PickupLocationId: parseInt(pickuplocation.value),
            ReasonId: parseInt(this.reasonSelected),
            //Rewards: this.rewards,
            //PhilaCycle: this.philaCycle,
            StatusID: 1,
            CreateDate: new Date(),
          };

          //console.log("hey");
          //console.log(this.token);
          axios({
            method: "POST",
            url: `${this.urlApi}/BinRequest/AddRequest`,
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
            data: JSON.stringify(formData),
          })
            .then(function (response) {
              if (response.data.status) {
                self.requestId = response.data.requestId;
                self.isModalVisible = true;
                self.isCompleted = true;
                self.mHeader = "Confirmation";
                self.mBody =
                  "Thank you for your request.\
                <br>We have emailed you copy of your submission.\
                <br>To claim your bin print this page and go to the nearest Sanitation Convenience Center.\
                <br>You can also go green and show your submission email on the screen of your device.";
                self.showModal();
              }
            })
            .catch(function (error) {
              this.msg.push(error);
            });
        }
      });
    },
    onCancel() {
      this.reset();
    },
    onSubmit() {
      self = this;

      this.$validator.validate().then((valid) => {
        if (valid) {
          axios
            .get(
              `${this.urlApi}/BinRequest/CountBinRequestsByAddress/${address.value}/${unit.value}`
            )
            .then((response) => {
              // JSON responses are automatically parsed.
              if (response.data >= 2) {
                self.isModalVisible = true;
                self.mHeader = "Message";

                self.mBody =
                  "<br>We're sorry, Philadelphia households are limited to one (1) free City funded bins every twelve months. \
                   <br>Please help reduce waste by repurposing any hard sided container under 32 Gallons and labeling it RECYCLING.";

                self.showModal();
              } else {
                self.saveRequest();
              }
            })
            .catch((e) => {
              this.msg.push(e);
            });
        }
      });
    },
    reset() {
      (this.firstName = ""),
        (this.lastName = ""),
        (this.address = ""),
        (this.unit = ""),
        (this.zipCode = ""),
        (this.email = ""),
        (this.phone = ""),
        (this.reason = false),
        (this.msg = []),
        (this.reasonSelected = ""),
        (this.checked = false),
        (this.pickupLocationId = 0),
        (this.isCompleted = false),
        (this.isModalVisible = false),
        this.$store.dispatch("setIsAddressValid", false);
      this.isButtonDisabled = false;
      this.$validator.reset();
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      //this.reset();
    },
    print() {
      window.print();
    },
  },
  computed: {
    modalHeader() {
      return this.mHeader;
    },
    modalBody() {
      return this.mBody;
    },
    forPrint() {
      return this.isCompleted;
    },
    disabledClass() {
      return this.isButtonDisabled
        ? "button content-type-featured full disabled"
        : "button content-type-featured full";
    },
  },
};
</script>

<style scoped>
.radioNoBullet {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mainDiv {
  padding-top: 20px;
}

.divx {
  font-size: 13px;
  color: black;
}

@media print {
  /*a[href]:after {
      display: none;
      visibility: hidden;
    }*/
  .noprint {
    display: none;
    visibility: hidden;
  }
}
</style>
